// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"e7d693ad","281":"9ccdea11","305":"ae651d80","419":"c0f38f60","522":"a4989696","584":"00f88b55","635":"daa3e484","787":"cef641ea","885":"cb287d42"}[chunkId] + ".chunk.js";
};